import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { useState } from "react";
import { ScoresProvider } from "./hooks/useScores";
import { Questions } from "./questions/Questions";
import { Result } from "./result/Result";
import theme from "./theme";
import { Top } from "./top/Top";

function App() {
  // 表示するページを管理するstate "top" | "questions" | "result"
  const [page, setPage] = useState("top");
  return (
    <ThemeProvider theme={theme}>
      <ScoresProvider>
        <CssBaseline />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: { pc: "center" },
            minHeight: "100vh",
            py: { mobile: "10vh", pc: "40px" },
            backgroundColor: "#EEEEEE",
          }}
        >
          <Box
            sx={{
              width: { mobile: "320px", pc: "800px" },
              minWidth: { mobile: "320px" },
              height: { pc: "600px" },
              minHeight: { mobile: "80vh", pc: "600px" },
              border: "#CCCCCC 1px solid",
              borderRadius: "5px",
              padding: "16px",
              backgroundColor: "#FFFFFF",
            }}
          >
            {/* pageの文字列によってどのコンポーネントを表示するかが決まる */}
            {page === "top" ? (
              <Top setPage={setPage} />
            ) : page === "questions" ? (
              <Questions setPage={setPage} />
            ) : page === "result" ? (
              <Result />
            ) : (
              console.warn("pageの値が不正です")
            )}
          </Box>
        </Box>
      </ScoresProvider>
    </ThemeProvider>
  );
}

export default App;
